<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column [label]="amountLabel" [derrors]="derrors">
                    <input
                      notdot
                      formControlName="totalAmount"
                      type="number"
                      [placeholder]="amountPlaceholder"
                      min="{{ minAmount }}"
                      fraction="2"
                    />
                    <i>€</i>
                  </pr-input-column>
                </div>
              </div>
              @if (minAmount > 0) {
                <info [option]="optionInfo1">
                  {{ minimumLabel }} {{ minAmount }} €.
                </info>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
